import React, { Fragment, useEffect, useState } from 'react';
import MergeProfileDialog from '../components/common/MergeProfileDialog';
import { fetchPtDir } from '../store/actions/app';
import { Patient } from '../store/types/patient';
import { useHistory } from 'react-router-dom';
import { GO_TO_PATIENTS_DETAILS } from '../routes/paths';
import { amIDoctorOnly } from '../store/idbHandler';
import { getAclViewClassName } from '../restrictions/utils';
import { SREV2 } from '../api/pushGenie';

interface Props {
    getPt: () => Promise<{
        pt: Patient;
    }>;
    onSuccess: () => void;
}

const MergePatienttPtDetails: React.FC<Props> = (props) => {
    const { getPt, onSuccess } = props;
    const [isModalOpen, setModelOpen] = React.useState(false);
    const [patient, setPt] = useState<Patient>();
    const [primaryProfile, setPrimaryProf] = useState<Patient>();
    const history = useHistory();

    async function onMergeModalClose() {
        setModelOpen((prevMergePtModal) => !prevMergePtModal);
    }

    useEffect(() => {
        if (primaryProfile && primaryProfile['localId']) {
            const primaryId = primaryProfile['localId'];

            fetchPtDir().then(() => {
                if (patient?.localId !== primaryId) {
                    history.replace(GO_TO_PATIENTS_DETAILS(primaryId, 'visit'));
                } else {
                    onSuccess();
                }
            });
        }
    }, [primaryProfile]);

    useEffect(() => {
        getPt().then((res) => setPt(res.pt));
    }, []);

    return (
        <Fragment>
            <p
                onClick={() => setModelOpen((prevModelOpen) => !prevModelOpen)}
                className={`inline focus:outline-none font-700 text-12 text-darwin-primary-500 underline cursor-pointer ${getAclViewClassName(
                    SREV2.MERGE_PATIENTS,
                )}`}
            >
                Merge Patients
            </p>

            {isModalOpen && (
                <MergeProfileDialog
                    onClose={onMergeModalClose}
                    ptOid={patient && patient['id'] ? patient['id'] : undefined}
                    setPrimaryProf={(val: Patient) => setPrimaryProf(val)}
                />
            )}
        </Fragment>
    );
};

export default MergePatienttPtDetails;
